import { isReasoningUIPart, isTextUIPart, isToolUIPart, ReasoningUIPart } from "ai";

import { AiChatMessage } from "../types";
import { isRunning, ToolPart } from "../Tool/helpers";

export type AiChatMessagePart = AiChatMessage["parts"][number];

export type AiChatThinkingPart = ReasoningUIPart | ToolPart;

type AiChatMessageSegment =
  | { type: "group"; key: number; parts: AiChatThinkingPart[] }
  | { type: "part"; key: number; part: AiChatMessagePart };

const splitsGroup = (part: AiChatMessagePart) => {
  if (part.type === "text") {
    return part.text.trim() !== "";
  }

  return part.type === "file" || part.type === "source-url" || part.type === "source-document";
};

export const getMessageSegments = (parts: AiChatMessagePart[]) => {
  const segments: AiChatMessageSegment[] = [];
  let group: AiChatThinkingPart[] | undefined;

  parts.forEach((part, index) => {
    if (isReasoningUIPart(part) || isToolUIPart(part)) {
      if (!group) {
        group = [];
        segments.push({ type: "group", key: index, parts: group });
      }
      group.push(part);
    } else if (splitsGroup(part)) {
      group = undefined;
      segments.push({ type: "part", key: index, part });
    }
  });

  return segments;
};

export const isGroupLive = (parts: AiChatThinkingPart[], isStreaming: boolean) =>
  isStreaming ||
  parts.some(
    (part) => isToolUIPart(part) && (part.state === "approval-requested" || isRunning(part))
  );

export const getMessageText = (message: AiChatMessage) =>
  message.parts
    .filter(isTextUIPart)
    .map((part) => part.text.trim())
    .filter(Boolean)
    .join("\n\n");
